import { Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

function ConditionalTooltip(props) {
  const { title, condition, children } = props;

  // States
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [isClient, setIsClient] = useState(false); // Needed for useLayout issue

  // Effects
  useEffect(() => {
    setIsClient(true);
  }, []);

  // Functions
  const handleTooltipOpen = () => {
    // setIsTooltipOpen(condition);
    if (condition) {
      setIsTooltipOpen(true);
    }
  };

  const handleTooltipClose = () => {
    setIsTooltipOpen(false);
  };

  // Render
  if (!isClient) {
    return null; // Return nothing during SSR
  }

  return (
    <Tooltip
      title={title}
      open={isTooltipOpen}
      onOpen={handleTooltipOpen}
      onClose={handleTooltipClose}
      followCursor
    >
      {children}
    </Tooltip>
  );
}

ConditionalTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  condition: PropTypes.bool,
  children: PropTypes.element.isRequired,
};

ConditionalTooltip.defaultProps = {
  condition: false,
};

export default ConditionalTooltip;
